import { createRoundedRectPolygon } from './shapes.js';
export const createRectangularHolePolygon = (hole)=>{
    const { $absCoords: center, width, height, cornerRadius } = hole;
    return createRoundedRectPolygon({
        center,
        width,
        height,
        cornerRadius
    });
};

//# sourceMappingURL=rectangular-hole.js.map